import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import { PLT_CONVERTER_ROUTE_PATH } from './config/pltConverterRoute'

/** 开发环境常见误报：Element Plus 布局触发的 ResizeObserver 循环，可忽略 */
function suppressBenignResizeObserverError(event) {
  const msg = String(event?.message || event?.reason?.message || '')
  if (/ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i.test(msg)) {
    event.stopImmediatePropagation?.()
    return true
  }
  return false
}
window.addEventListener('error', suppressBenignResizeObserverError)
window.addEventListener('unhandledrejection', (event) => {
  if (suppressBenignResizeObserverError(event)) {
    event.preventDefault()
  }
})

// hash 路由下兼容直接访问公开路径（无 #）
if (
  typeof window !== 'undefined' &&
  window.location.pathname.replace(/\/$/, '') === PLT_CONVERTER_ROUTE_PATH &&
  !window.location.hash
) {
  window.location.replace(`${window.location.origin}/#${PLT_CONVERTER_ROUTE_PATH}`)
}

// 全局使用简体中文（分页、日期、弹窗等组件文案）
createApp(App).use(router).use(ElementPlus, { locale: zhCn }).mount('#app')
